module.exports = __webpack_public_path__ + "static/img/Big_Daddy.3333164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Big_Daddy.jpg
// module id = ZWGL
// module chunks = 1